export function watchProcessingPicker(
  win: EventTarget,
  doc: EventTarget & { hidden: boolean },
  onSkip: () => void,
): () => void {
  let dismissed = false;
  const skip = () => {
    if (dismissed) return;
    dismissed = true;
    onSkip();
  };
  const visibility = () => { if (doc.hidden) skip(); };
  const timer = setTimeout(skip, 30000);
  win.addEventListener('blur', skip);
  doc.addEventListener('visibilitychange', visibility);
  if (doc.hidden) skip();
  return () => {
    clearTimeout(timer);
    win.removeEventListener('blur', skip);
    doc.removeEventListener('visibilitychange', visibility);
  };
}
